import React, { useState, useEffect } from 'react';
import { Modal, Form, Input, Select, Button, Row, Col, Typography } from 'antd';
import { countries } from '../utils/countries';

const { TextArea } = Input;
const { Title, Text } = Typography;

const GemContextModal = ({ open, onClose, onSubmit, initialContext = null }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (initialContext) {
      form.setFieldsValue(initialContext);
    } else {
      form.resetFields();
    }
  }, [initialContext, form, open]);

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      onSubmit(values);
      form.resetFields();
      onClose();
    } catch (error) {
      console.error('Validation failed:', error);
    }
  };

  return (
    <Modal
      open={open}
      onCancel={onClose}
      width={800}
      footer={[
        <Button key="cancel" onClick={onClose}>
          Cancel
        </Button>,
        <Button key="submit" type="primary" onClick={handleSubmit}>
          Start Conversation
        </Button>,
      ]}
      title={
        <div>
          <Title level={4} style={{ margin: 0 }}>
            Strategic Objective Details
          </Title>
          <Text type="secondary">
            Provide details about your strategic objective to get tailored insights
          </Text>
        </div>
      }
    >
      <Form
        form={form}
        layout="vertical"
        style={{ marginTop: 16 }}
      >
        <Form.Item
          name="objective"
          label="What is your strategic objective?"
        >
          <TextArea
            rows={2}
            placeholder="e.g., Increase market share by 20% in the SMB segment"
          />
        </Form.Item>

        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="companyName"
              label="Company Name"
            >
              <Input placeholder="Your company name" />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              name="industry"
              label="Industry"
            >
              <Input placeholder="e.g., Technology, Healthcare, Finance" />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="country"
              label="Country"
            >
              <Select
                showSearch
                placeholder="Select country"
                optionFilterProp="children"
                allowClear
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
              >
                {countries.map((country) => (
                  <Select.Option key={country} value={country}>
                    {country}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              name="companySize"
              label="Company Size"
            >
              <Select placeholder="Select company size" allowClear>
                <Select.Option value="1-10">1-10 employees</Select.Option>
                <Select.Option value="11-50">11-50 employees</Select.Option>
                <Select.Option value="51-200">51-200 employees</Select.Option>
                <Select.Option value="201-500">201-500 employees</Select.Option>
                <Select.Option value="501-1000">501-1000 employees</Select.Option>
                <Select.Option value="1000+">1000+ employees</Select.Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="timeFrame"
              label="Time Frame"
            >
              <Select placeholder="Select time frame" allowClear>
                <Select.Option value="3 months">3 months</Select.Option>
                <Select.Option value="6 months">6 months</Select.Option>
                <Select.Option value="12 months">12 months</Select.Option>
                <Select.Option value="18 months">18 months</Select.Option>
                <Select.Option value="24 months">24 months</Select.Option>
                <Select.Option value="3+ years">3+ years</Select.Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>

        <Form.Item
          name="challenges"
          label="Current Challenges / Pain Points"
        >
          <TextArea
            rows={3}
            placeholder="Describe the main challenges you're facing in achieving this objective"
          />
        </Form.Item>

        <Form.Item
          name="additionalContext"
          label="Additional Context (Optional)"
        >
          <TextArea
            rows={2}
            placeholder="Any other relevant information that could help provide better insights"
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default GemContextModal;
